import { RoleInfoEntity } from "@/model/system";
import session from "@/utils/session";
export const enum shareKeys {
  changeProducts = "changeProducts",
  productDetails = "productDetails",
  localContrarys = "localContrarys",
  conformGoods = "conformGoods",

  realIndex = "realIndex",
}

export default {
  name:'',
  consumers: [],
  City: {},
  editRole: {
    CountryCode:'',
    ContactInfo:{
      ContactPhone: "",
      ContactEmail: "",
    }
  },
  selected:'',
  bookingType: "",
  ServiceType:'',

  costCenters: [],
  costCenter: {},

  tripIntents: [],
  tripIntent: {},

  contraryReasons: [],
  contraryReason: {},

  projectCodes: [],
  projectCode: {},

  AirwayList: [],
  ArriveAirportList: [],
  DepartAirportList: [],

  demandContent: "",

  keyword: {} as any,
  serviceType: "",

  indexSurvey: false,

  trafficDatas: {} as any,

  get changeSource(): any {
    return session.get(shareKeys.changeProducts);
  },
  set changeSource(value: any) {
    session.set(shareKeys.changeProducts, value);
  },
  get ProductDetails(): any {
    return session.get(shareKeys.productDetails);
  },
  set ProductDetails(value: any) {
    session.set(shareKeys.productDetails, value);
  },
  get localContrarys(): any {
    return session.get(shareKeys.localContrarys);
  },
  set localContrarys(value: any) {
    session.set(shareKeys.localContrarys, value);
  },
  get conformGoods(): any {
    return session.get(shareKeys.conformGoods);
  },
  set conformGoods(value: any) {
    session.set(shareKeys.conformGoods, value);
  },

  get realIndex(): any {
    return session.get(shareKeys.realIndex);
  },
  set realIndex(value: any) {
    session.set(shareKeys.realIndex, value);
  },
};
